import {
  CopyButton,
  CopyRow,
  MessageBox,
  MessageTextArea,
} from '../Referral.styles';

interface ReferralShareMessageProps {
  message: string;
  onMessageChange: (value: string) => void;
  onCopyMessage: () => void;
  disabled?: boolean;
}

const ReferralShareMessage: React.FC<ReferralShareMessageProps> = ({
  message,
  onMessageChange,
  onCopyMessage,
  disabled,
}) => {
  return (
    <MessageBox>
      <CopyRow>
        <CopyButton type="button" onClick={onCopyMessage} disabled={disabled}>
          copy
        </CopyButton>
      </CopyRow>
      <MessageTextArea
        value={message}
        disabled={disabled}
        readOnly={disabled}
        onChange={(event) => onMessageChange(event.target.value)}
      />
    </MessageBox>
  );
};

export default ReferralShareMessage;
